// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1jDaq","rootCenter":"LoadMoreObserver_rootCenter__1Tjuf","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__WCl68"};